// lib/generation-output-layer.ts
import type { Layer } from '#types/types';

export const materializeProjectGenerationLayer = (layer: Layer, projectId: string): Layer => ({
  ...layer,
  projectId: projectId.trim(),
  layerWorkspaceId: null,
  imageSrc:
    layer.type === 'video'
      ? (layer.imageSrc ?? layer.videoFramesUrls?.[0] ?? null) || undefined
      : layer.imageSrc,
});
